import { call, put, takeLatest } from "redux-saga/effects";
import { authAPI } from "../../../services/auth/index"
import { createAccount, CREATE_ACCOUNT } from "../../actions/auth.action"

function* handleCreateAccount(action) {
  try {
    const { data : resData} = yield call(authAPI.createAccount, action.payload);
    //extract the data here     
    yield put(createAccount.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(createAccount.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* createAccountSaga() {
  yield takeLatest(CREATE_ACCOUNT.REQUEST, handleCreateAccount);
}

export default createAccountSaga;
